var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-bar"},[_c('AppInput',_vm._b({attrs:{"append-icon":"far fa-search"},on:{"input":_vm.updateSearch}},'AppInput',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }